export const Texts = {
  PREV_TEXT: 'Prev',
  NEXT_TEXT: 'Next',
  VIEW_ALL_TEXT: 'View All',
  PATH: '/support-a-learner/transparency-dashboard'
};
